import { User } from "models/user"
import { callAxios } from "plugin/call.axios"

export const LOGIN_USER = (userLoginInfo: User) => {
    return callAxios({
        url: '',
        method: 'POST',
        data: userLoginInfo
    })
}

export const STORE_FEEDBACK = (feedback: any) => { 
    return callAxios({
        url: '',
        method: 'POST',
        data: feedback
    })
}